import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { ArrowDown, ArrowUpRight } from "lucide-react";
import { IMAGES, LOGO_DIAMOND, lineReveal } from "@/lib/site";

const HEADLINE = ["ISKLJUČIVO", "META OGLASI.", "JER ZNAMO", "ŠTO RADI"];

export default function Hero() {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start start", "end start"] });
  const y = useTransform(scrollYProgress, [0, 1], ["0%", "22%"]);
  const scale = useTransform(scrollYProgress, [0, 1], [1, 1.12]);
  const opacity = useTransform(scrollYProgress, [0, 0.8], [1, 0]);

  return (
    <section id="pocetna" ref={ref} className="relative min-h-[100svh] w-full overflow-hidden bg-[#050505]">
      {/* Parallax background — [PLACEHOLDER: zamijeniti fotografijom/videom iz vlastitog ureda] */}
      <motion.div style={{ y, scale }} className="absolute inset-0 z-0">
        <img
          src="/office/hero.webp"
          alt="Onarf Marketing — rad na Meta oglasima u uredu"
          className="h-full w-full object-cover"
        />
        <div className="absolute inset-0 bg-black/70" />
        <div className="absolute inset-0 bg-gradient-to-t from-[#050505] via-[#050505]/40 to-[#050505]/60" />
      </motion.div>

      <motion.div style={{ opacity }} className="relative z-10 mx-auto flex min-h-[100svh] max-w-[1400px] flex-col justify-end px-5 pb-16 pt-32 md:px-10 md:pb-24">
        <motion.div
          initial={{ opacity: 0, x: -12 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.7 }}
          className="mb-8 flex items-center gap-3"
        >
          <img src={LOGO_DIAMOND} alt="" className="h-4 w-4 object-contain" />
          <span className="eyebrow">Onarf Marketing — Hrvatska</span>
        </motion.div>

        <h1 className="font-display text-[clamp(2.15rem,11vw,3.25rem)] font-black uppercase leading-[0.9] tracking-tighter text-white sm:text-7xl sm:leading-[0.88] lg:text-[6rem]">
          {HEADLINE.map((line, i) => (
            <span key={i} className="line-mask">
              <motion.span
                variants={lineReveal}
                initial="hidden"
                animate="show"
                custom={i}
                className="block"
              >
                {line === "META OGLASI." ? (
                  <span className="text-[#50C878]">{line}</span>
                ) : (
                  line
                )}
              </motion.span>
            </span>
          ))}
        </h1>

        <motion.p
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.7 }}
          className="mt-8 max-w-xl text-base leading-relaxed text-white/70 md:text-lg"
        >
          Ne radimo SEO, web dizajn ni vođenje mreža. Radimo jednu stvar — Meta oglase
          koji pune kalendar raznih klinika stvarnim klijentima. Rezultati, ne obećanja.
        </motion.p>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.85 }}
          className="mt-10 flex flex-col gap-4 sm:flex-row sm:items-center"
        >
          <a
            href="#kontakt"
            data-testid="hero-cta"
            className="group flex items-center justify-center gap-3 bg-[#50C878] px-9 py-5 font-display text-sm font-extrabold uppercase tracking-widest text-black transition-colors duration-300 hover:bg-[#3EB264]"
          >
            Zakažite besplatne konzultacije
            <ArrowUpRight size={18} className="transition-transform duration-300 group-hover:translate-x-1 group-hover:-translate-y-1" />
          </a>
          <a
            href="#rezultati"
            data-testid="hero-secondary"
            className="flex items-center justify-center gap-3 border border-[#333] px-9 py-5 font-display text-sm font-bold uppercase tracking-widest text-white transition-colors duration-300 hover:border-[#50C878]"
          >
            Pogledajte rezultate
          </a>
        </motion.div>
      </motion.div>

      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ delay: 1.4 }}
        className="absolute bottom-8 right-5 z-10 hidden items-center gap-2 text-white/40 md:right-10 md:flex"
      >
        <ArrowDown size={16} className="animate-bounce" />
        <span className="font-display text-[0.7rem] font-bold uppercase tracking-[0.2em]">Skrolajte</span>
      </motion.div>
    </section>
  );
}
